var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.billingSummaryStatus, function(billingStatusData) {
      return _c(
        "span",
        { staticStyle: { padding: "8px", "font-weight": "700" } },
        [
          _vm._v(
            "\n    " +
              _vm._s(billingStatusData.name) +
              ": " +
              _vm._s(billingStatusData.total) +
              ";\n    " +
              _vm._s(billingStatusData.percentageOfTotal) +
              "% |\n  "
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }